<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">
        <h2>TIME HAS EXPIRED</h2>
        <h4><a @click.prevent="reload"><u>Reload page</u></a> to start again.</h4>
      </div>
    </div>

  </div>
</template>

<script>
    import {elements_classes} from '../mixins/elements_classes'

    export default {
        name: "time_passed",
        mixins: [elements_classes],
        data(){
            return{
                // this_page: 'time_passed'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        },
        methods:{
            reload(){
                window.location.reload()
            }
        }
    }
</script>

<style scoped>
</style>